export default {
  please_pay_attention: 'Tafadhali zingatia hili!',
  new_deposit_instructions: 'Muongozo mpya wa namna ya kuweka pesa!',
  invoice_flow__step: 'Hatua {index}: ',

  //Vodacom
  invoice_flow__vodacom_steps_step_1: 'Piga *150*00#',
  invoice_flow__vodacom_steps_step_2: 'Chagua 4 (Lipa kwa M-PESA)',
  invoice_flow__vodacom_steps_step_3: 'Chagua 4 (Weka namba ya kampuni)',
  invoice_flow__vodacom_steps_step_4: 'Weka namba ya kampuni: {business_number}',
  invoice_flow__vodacom_steps_step_5: 'Weka namba ya kumbukumbu ya malipo: {reference_number}',
  invoice_flow__vodacom_steps_step_6: 'Weka kiasi: {amount}',
  invoice_flow__vodacom_steps_step_7: 'Weka namba ya siri',
  invoice_flow__vodacom_steps_step_8: 'Chagua 1 kuhakiki muhamala',

  //Airtel
  invoice_flow__airtel_steps_step_1: 'Piga *150*60#',
  invoice_flow__airtel_steps_step_2: 'Chagua 5 (Lipa Bili)',
  invoice_flow__airtel_steps_step_3: 'Chagua 4 (Weka namba ya kampuni)',
  invoice_flow__airtel_steps_step_4: 'Andika namba ya bishara: {business_number}',
  invoice_flow__airtel_steps_step_5: 'Ingiza kiasi cha pesa: {amount}',
  invoice_flow__airtel_steps_step_6: 'Ingiza namba ya kumbukumbu: {reference_number}',
  invoice_flow__airtel_steps_step_7: 'Ingiza namba ya siri kulipia',

  //Tigo
  invoice_flow__tigo_steps_step_1: 'Piga *150*01#',
  invoice_flow__tigo_steps_step_2: 'Chagua 4 (Lipa Bili)',
  invoice_flow__tigo_steps_step_3: 'Chagua 3 (Ingiza namba ya kampuni)',
  invoice_flow__tigo_steps_step_4: 'Ingiza namba ya kampuni: {business_number}',
  invoice_flow__tigo_steps_step_5: 'Weka kumbukumbu namba: {reference_number}',
  invoice_flow__tigo_steps_step_6: 'Ingiza kiasi: {amount}',
  invoice_flow__tigo_steps_step_7: 'Ingiza namba ya siri kuhakiki',

  //Halopesa
  invoice_flow__halopesa_steps_step_1: 'Piga *150*88#',
  invoice_flow__halopesa_steps_step_2: 'Chagua 4 (Lipa Bili)',
  invoice_flow__halopesa_steps_step_3: 'Chagua 3 (Namba ya kampuni)',
  invoice_flow__halopesa_steps_step_4: 'Weka namba ya kampuni: {business_number}',
  invoice_flow__halopesa_steps_step_5: 'Weka kumbukumbu namba: {reference_number}',
  invoice_flow__halopesa_steps_step_6: 'Weka kiasi: {amount}',
  invoice_flow__halopesa_steps_step_7: 'Weka namba ya siri',
  invoice_flow__halopesa_steps_step_8: 'Bonyeza 1 kuhakiki',

  //Zantel ezypesa
  invoice_flow__zantel_ezypesa_steps_step_1: 'Piga *150*02#',
  invoice_flow__zantel_ezypesa_steps_step_2: 'Chagua 4 (Malipo)',
  invoice_flow__zantel_ezypesa_steps_step_3: 'Chagua 3 (Namba ya kampuni)',
  invoice_flow__zantel_ezypesa_steps_step_4: 'Weka namba ya kampuni: {business_number}',
  invoice_flow__zantel_ezypesa_steps_step_5: 'Weka kumbukumbu namba: {reference_number}',
  invoice_flow__zantel_ezypesa_steps_step_6: 'Weka kiasi: {amount}',
  invoice_flow__zantel_ezypesa_steps_step_7: 'Weka namba ya siri kuhakiki',
};
